// services/hookService/uploadLoanRequestFile/usePostUploadCreditLoanImg.ts
import {AxiosError} from 'axios';
import {useMutation, UseMutationResult} from 'react-query';
import {toast} from 'react-toastify';
import postUploadCreditLoanImg from './postUploadCreditLoanImg';

interface IUsePostUploadCreditLoanImgProps {
  onSuccess?: (data: ILoanRequestFileResponse) => void;
  onError?: (error: AxiosError) => void;
  showToast?: boolean;
}

const usePostUploadCreditLoanImg = ({
  onSuccess,
  onError,
  showToast = true,
}: IUsePostUploadCreditLoanImgProps = {}): UseMutationResult<
  ILoanRequestFileResponse,
  AxiosError,
  ILoanRequestFilePayload
> => {
  return useMutation<
    ILoanRequestFileResponse,
    AxiosError,
    ILoanRequestFilePayload
  >({
    mutationFn: (payload: ILoanRequestFilePayload) =>
      postUploadCreditLoanImg(payload),
    onSuccess: data => {
      if (showToast) {
        toast.success('فایل با موفقیت آپلود شد');
      }
      onSuccess?.(data);
    },
    onError: (error: AxiosError) => {
      if (showToast) {
        toast.error(
          (error?.response?.data as any)?.message ||
            'خطا در آپلود فایل. لطفا مجددا تلاش کنید',
        );
      }
      onError?.(error);
    },
  });
};

export default usePostUploadCreditLoanImg;
